var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifierPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 10C14 9.44772 13.5523 9 13 9C12.4477 9 12 9.44772 12 10V12H10C9.44772 12 9 12.4477 9 13C9 13.5523 9.44772 14 10 14H12V16C12 16.5523 12.4477 17 13 17C13.5523 17 14 16.5523 14 16V14H16C16.5523 14 17 13.5523 17 13C17 12.4477 16.5523 12 16 12H14V10Z",
    fill: "#023F80"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C8.02944 4 4 8.02944 4 13C4 17.9706 8.02944 22 13 22C15.125 22 17.078 21.2635 18.6177 20.0319L23.2929 24.7071C23.6834 25.0976 24.3166 25.0976 24.7071 24.7071C25.0976 24.3166 25.0976 23.6834 24.7071 23.2929L20.0319 18.6177C21.2635 17.078 22 15.125 22 13C22 8.02944 17.9706 4 13 4ZM13 6C9.13401 6 6 9.13401 6 13C6 16.866 9.13401 20 13 20C16.866 20 20 16.866 20 13C20 9.13401 16.866 6 13 6Z",
    fill: "#023F80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifierPlus);
export default __webpack_public_path__ + "static/media/magnifier_plus.b6f6fb13b83bf40541863ac35d8cd870.svg";
export { ForwardRef as ReactComponent };